import React, {useEffect, useState} from "react";
import {StatusEmun} from "../../../interface/challenge/details";
import styled from "styled-components";




export const StatusWidget: React.FC<{ status: string }> = ({status}) => {
    // const [text,setText] = useState('');
    // useEffect(()=>{
    // let _text = ';'
    // switch (status) {
    //     case StatusEmun.Accepted:
    //         _text = 'Accepted';
    //         break;
    //     case StatusEmun.Pending:
    //         _text = 'Pending';
    //
    //         break;
    //     case StatusEmun.Denied:
    //         _text = 'Denied';
    //         break;
    //     case StatusEmun.Arbiter:
    //         _text = 'Arbiter';
    //         break;
    //     case StatusEmun.Challenge:
    //         _text = 'Challenge';
    //         break;
    // }
    //     setText(_text);
    // },[])
    return (
        <StatusStyle status={status}>
            {status}
        </StatusStyle>
    );
}

const StatusStyle = styled.p<{ status: string }>`
  color: ${({theme, status}) => theme.statusColor[status]};
`

/*
  color: ${({status}) => {
    let _color;
    switch (status) {
      case StatusEmun.Accepted:
        _color = '#1A9C55';
        break;
      case StatusEmun.Pending:
        _color = '#FF7300';

        break;
      case StatusEmun.Denied:
        _color = '#D0021C';
        break;
      case StatusEmun.Arbiter:
        _color = '#1A9C55';
        break;
      case StatusEmun.Challenge:
        _color = '#1A9C55';
        break;
    }
    return _color;
  }};
 */
